import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#4043ac",
    },
    secondary: {
      main: "#4043ac",
    },

    warning: {
      main: "#F59E0B", // Amber 500 (good warning color)
      contrastText: "#FFFFFF",
    },
    error: {
      main: "#DC2626", // Red 600
    },
    info: {
      main: "#3B82F6", // Blue 500
    },
  },
  typography: {
    fontSize: 12,
  },
});
